import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { Jurisdiction } from "../../models/jurisdiction";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import dayjs from "dayjs";
import { CreateInmateContact, SharedContactRepository } from "../../repositories/shared-contact-repository";
import { ContactResponse } from "../../models/contact";

@Component({
	selector: "jhm-create-contact",
	imports: [MatFormFieldModule, MatInputModule, FormsModule, MatOptionModule,
		MatSelectModule, MatDatepickerModule],
	templateUrl: "./create-contact.component.html",
	styleUrl: "./create-contact.component.scss"
})
export class CreateContactComponent implements OnInit {
	@Output()
	public exit: EventEmitter<ContactResponse> = new EventEmitter<ContactResponse>();
	public firstName: string;
	public lastName: string;
	public bookingNumber: string;
	public bookedDate: Date;
	public bookedDateString: string;
	public birthDate: Date;
	public birthDateString: string;
	public selectedJurisdictionId: string;
	public selectedJurisdiction: Jurisdiction;
	public jurisdictionOptions: Jurisdiction[] = [];
	public canSubmit: boolean = false;

	private contactRepository: SharedContactRepository = inject(SharedContactRepository);

	ngOnInit(): void
	{
		this.contactRepository.getPotentialJurisdictions().subscribe((jurisdictions: Jurisdiction[]) =>
		{
			this.jurisdictionOptions = jurisdictions;
			if (this.jurisdictionOptions.length === 1)
			{
				this.selectedJurisdiction = this.jurisdictionOptions[0];
			}
		});
	}

	public cancel(): void
	{
		this.exit.emit(null);
	}

	public jurisdictionChanged($event: any): void
	{
		this.selectedJurisdiction = this.jurisdictionOptions.find((jurisdiction: Jurisdiction) => {
			return jurisdiction.id === this.selectedJurisdictionId;
		});
	}

	public dateChanged(type: string): void
	{
		if (type === "BOOKED")
		{
			if (!this.bookedDate) {
				this.bookedDateString = null;
			} else {
				const bookedString: string = dayjs(this.bookedDate).format("YYYY-MM-DD");
				this.bookedDateString = bookedString;
			}
		}
		else if (type === "BIRTH")
		{
			if (!this.birthDate) {
				this.birthDateString = null;
			} else {
				const birthString: string = dayjs(this.birthDate).format("YYYY-MM-DD");
				this.birthDateString = birthString;
			}
		}
	}

	public checkIfCanSubmit(): void
	{
		this.canSubmit = true && (!!this.firstName && !!this.lastName && !!this.bookingNumber
			&& !!this.bookedDateString && !!this.birthDateString && !!this.selectedJurisdiction?.id);
	}

	public createContact(): void
	{
		const newContact: CreateInmateContact = new CreateInmateContact(this.firstName, this.lastName,
			this.bookingNumber, this.bookedDateString, this.birthDateString, this.selectedJurisdiction.id);
		this.contactRepository.createInmateContact(newContact).subscribe((contact: ContactResponse) => {
			this.exit.emit(contact);
		});
	}
}
